/**
 * @generated SignedSource<<8bc965cbf84f01f022b28e07876bb869>>
 * @relayHash 5f1e035b977d3535182c47a0c52e6c5a
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5f1e035b977d3535182c47a0c52e6c5a

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type De_createOrReuseEpisodeOfCareInput = {
  diagnosisCode: string;
  patientId: string;
  relatedConditions: ReadonlyArray<string>;
};
export type deCreateOrReuseEpisodeOfCareMutation$variables = {
  addConnections: ReadonlyArray<string>;
  input: De_createOrReuseEpisodeOfCareInput;
};
export type deCreateOrReuseEpisodeOfCareMutation$data = {
  readonly createOrReuseEpisodeOfCare: {
    readonly episodeOfCare: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"deEpisodeOfCareFragment">;
    } | null;
  };
};
export type deCreateOrReuseEpisodeOfCareMutation = {
  response: deCreateOrReuseEpisodeOfCareMutation$data;
  variables: deCreateOrReuseEpisodeOfCareMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addConnections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "diagnosisCode",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "IcdDiagnosis",
  "kind": "LinkedField",
  "name": "icdDiagnosis",
  "plural": false,
  "selections": [
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAssociation",
      "storageKey": null
    },
    (v4/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "secondaryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "associationType",
      "storageKey": null
    },
    (v5/*:: as any*/)
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdBy",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progressNoteId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reason",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completedAt",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attachmentType",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uploadStatus",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "conditions",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allergies",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v29 = [
  (v3/*:: as any*/),
  (v27/*:: as any*/),
  (v28/*:: as any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedBy",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "word",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "synonym",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "from",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "to",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileId",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedAt",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedBy",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "concludedAt",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "concludedBy",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "DocumentFileMetadata",
  "kind": "LinkedField",
  "name": "fileMetadata",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "documentType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "extension",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lengthInKilobytes",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sessionId",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "deCreateOrReuseEpisodeOfCareMutation",
    "selections": [
      {
        "alias": "createOrReuseEpisodeOfCare",
        "args": (v2/*:: as any*/),
        "concreteType": "De_createOrReuseEpisodeOfCarePayload",
        "kind": "LinkedField",
        "name": "de_createOrReuseEpisodeOfCare",
        "plural": false,
        "selections": [
          {
            "alias": "episodeOfCare",
            "args": null,
            "concreteType": "de_EpisodeOfCare",
            "kind": "LinkedField",
            "name": "de_EpisodeOfCare",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "deEpisodeOfCareFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "deCreateOrReuseEpisodeOfCareMutation",
    "selections": [
      {
        "alias": "createOrReuseEpisodeOfCare",
        "args": (v2/*:: as any*/),
        "concreteType": "De_createOrReuseEpisodeOfCarePayload",
        "kind": "LinkedField",
        "name": "de_createOrReuseEpisodeOfCare",
        "plural": false,
        "selections": [
          {
            "alias": "episodeOfCare",
            "args": null,
            "concreteType": "de_EpisodeOfCare",
            "kind": "LinkedField",
            "name": "de_EpisodeOfCare",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isVirtual",
                "storageKey": null
              },
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isUpdatable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "de_ProgressNoteConnection",
                "kind": "LinkedField",
                "name": "progressNotes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "de_ProgressNoteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "de_ProgressNote",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v11/*:: as any*/),
                          (v3/*:: as any*/),
                          (v12/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "episodeOfCareId",
                            "storageKey": null
                          },
                          (v13/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Appointment",
                            "kind": "LinkedField",
                            "name": "appointment",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "access",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "appointmentType",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "conclusionStatus",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "asyncRequestStatus",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "specialty",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "service",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "patientPhoneNumber",
                                "storageKey": null
                              },
                              (v9/*:: as any*/),
                              (v14/*:: as any*/),
                              (v15/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isCompleted",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isInvoiced",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isPartnerInVideoCall",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "questionnaireId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "QuestionnaireCriticalitySummaryOutput",
                                "kind": "LinkedField",
                                "name": "questionnaireCriticalitySummary",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "useCaseName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "criticals",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "warnings",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "infos",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "questionnaireType",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "channel",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "callerRole",
                                "storageKey": null
                              },
                              (v16/*:: as any*/),
                              (v17/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasChatTranscript",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "canUseDoc2U",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ch_TelephoneLine",
                                "kind": "LinkedField",
                                "name": "telephoneLine",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ch_TelephoneLineTranslation",
                                    "kind": "LinkedField",
                                    "name": "telephoneLineTranslations",
                                    "plural": true,
                                    "selections": [
                                      (v16/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "content",
                                        "storageKey": null
                                      },
                                      (v3/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v3/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AppointmentAttachment",
                                "kind": "LinkedField",
                                "name": "appointmentAttachments",
                                "plural": true,
                                "selections": [
                                  (v3/*:: as any*/),
                                  (v18/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "thumbnailUrl",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "uploadDate",
                                    "storageKey": null
                                  },
                                  (v19/*:: as any*/),
                                  (v20/*:: as any*/),
                                  (v21/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "uploadSource",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Address",
                                "kind": "LinkedField",
                                "name": "patientAddress",
                                "plural": false,
                                "selections": [
                                  (v22/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "countryCode",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "houseNumberStreet",
                                    "storageKey": null
                                  },
                                  (v23/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BillingAttribute",
                                "kind": "LinkedField",
                                "name": "billingAttribute",
                                "plural": false,
                                "selections": [
                                  (v3/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isNotBillable",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "notBillableReason",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "treatmentReason",
                                    "storageKey": null
                                  },
                                  (v14/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isVisualSymptomExamination",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "currentGestationWeek",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "organisationId",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "dateOfAccident",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "accidentReference",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isEmployer",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "lawType",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "ivgCaseReference",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mvgCaseReference",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "HealthOverview",
                                "kind": "LinkedField",
                                "name": "healthOverview",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "VitalSign",
                                    "kind": "LinkedField",
                                    "name": "vitalSign",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "bloodPressureDiastolic",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "bloodPressureSystolic",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "bloodSugarMgDl",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "bloodSugarMmol",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "bodyTemperature",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "breathRate",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "cReactiveProtein",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "glasgowComaScaleEye",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "glasgowComaScaleMotor",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "glasgowComaScaleVerbal",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "heartRate",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "oxygenSaturation",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "strepATestPositive",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "visualAnalogPainScale",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GeneralHealthInformation",
                                    "kind": "LinkedField",
                                    "name": "generalHealthInformation",
                                    "plural": false,
                                    "selections": [
                                      (v24/*:: as any*/),
                                      (v25/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "medication",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RequestedMedication",
                                "kind": "LinkedField",
                                "name": "requestedMedications",
                                "plural": true,
                                "selections": [
                                  (v26/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mainSubstance",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "packageSize",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "pharmaCode",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "productUrl",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "requestType",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "IcdDiagnosis",
                                "kind": "LinkedField",
                                "name": "suggestedQuestionnaireDiagnosisCodes",
                                "plural": true,
                                "selections": [
                                  (v4/*:: as any*/),
                                  (v3/*:: as any*/),
                                  (v5/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "partnerUserEmail",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "medgateConnectChannel",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "partnerType",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Appointment",
                            "kind": "LinkedField",
                            "name": "followUpAppointment",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "date",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "slotId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "assignedTo",
                                "storageKey": null
                              },
                              (v15/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "initialBookedDateTime",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MedgateEmployee",
                                "kind": "LinkedField",
                                "name": "initialAssignedToUser",
                                "plural": false,
                                "selections": (v29/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rescheduledBy",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rescheduledAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MedgateEmployee",
                                "kind": "LinkedField",
                                "name": "rescheduledByUser",
                                "plural": false,
                                "selections": (v29/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "takenBy",
                                "storageKey": null
                              },
                              (v17/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v8/*:: as any*/),
                          (v30/*:: as any*/),
                          (v10/*:: as any*/),
                          (v9/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "de_ProgressNoteBetterDoc",
                            "kind": "LinkedField",
                            "name": "betterDoc",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isUsed",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rejectionReason",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "de_PointOfCare",
                            "kind": "LinkedField",
                            "name": "pointOfCare",
                            "plural": false,
                            "selections": [
                              (v11/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "medical",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actual",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "reasonForChoosingActual",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isDoctorVisitAvoided",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "careProviderId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Purpose",
                                "kind": "LinkedField",
                                "name": "purpose",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "physicalExam",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "laboratory",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "instrumentalExamination",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "specialtyId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PointOfCareSpecialty",
                                "kind": "LinkedField",
                                "name": "pointOfCareSpecialty",
                                "plural": false,
                                "selections": [
                                  (v3/*:: as any*/),
                                  (v31/*:: as any*/),
                                  (v32/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PointOfCareSpecialtyTranslation",
                                    "kind": "LinkedField",
                                    "name": "specialtyTranslations",
                                    "plural": true,
                                    "selections": [
                                      (v16/*:: as any*/),
                                      (v26/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "betterDocKey",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "timeToTreatType",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TreatmentPlan",
                            "kind": "LinkedField",
                            "name": "treatmentPlan",
                            "plural": false,
                            "selections": [
                              (v33/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "followUpInstructions",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "recommended",
                                "storageKey": null
                              },
                              (v34/*:: as any*/),
                              (v35/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "anamnesis",
                            "storageKey": null
                          },
                          {
                            "alias": "therapyPrescription",
                            "args": null,
                            "concreteType": "de_TherapyPrescription",
                            "kind": "LinkedField",
                            "name": "de_therapyPrescription",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              (v36/*:: as any*/),
                              (v12/*:: as any*/),
                              (v4/*:: as any*/),
                              (v37/*:: as any*/),
                              (v38/*:: as any*/),
                              (v10/*:: as any*/),
                              (v9/*:: as any*/),
                              (v30/*:: as any*/),
                              (v8/*:: as any*/),
                              (v39/*:: as any*/),
                              (v40/*:: as any*/),
                              (v41/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "treatmentUnit",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "frequency",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "requestTherapyReport",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "symptoms",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "otherSymptoms",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "additionalInformation",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "therapy",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "sickLeave",
                            "args": null,
                            "concreteType": "de_SickLeave",
                            "kind": "LinkedField",
                            "name": "de_sickLeave",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              (v36/*:: as any*/),
                              (v12/*:: as any*/),
                              (v37/*:: as any*/),
                              (v38/*:: as any*/),
                              (v10/*:: as any*/),
                              (v9/*:: as any*/),
                              (v30/*:: as any*/),
                              (v8/*:: as any*/),
                              (v34/*:: as any*/),
                              (v35/*:: as any*/),
                              (v39/*:: as any*/),
                              (v40/*:: as any*/),
                              (v41/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "certificateType",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "generalAttestation",
                            "args": null,
                            "concreteType": "de_GeneralAttestation",
                            "kind": "LinkedField",
                            "name": "de_generalAttestation",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              (v36/*:: as any*/),
                              (v12/*:: as any*/),
                              (v38/*:: as any*/),
                              (v37/*:: as any*/),
                              (v10/*:: as any*/),
                              (v9/*:: as any*/),
                              (v30/*:: as any*/),
                              (v8/*:: as any*/),
                              (v26/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "subject",
                                "storageKey": null
                              },
                              (v39/*:: as any*/),
                              (v40/*:: as any*/),
                              (v41/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "message",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "attestationGuardian",
                            "args": null,
                            "concreteType": "de_AttestationGuardian",
                            "kind": "LinkedField",
                            "name": "de_attestationGuardian",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              (v27/*:: as any*/),
                              (v28/*:: as any*/),
                              (v36/*:: as any*/),
                              (v12/*:: as any*/),
                              (v38/*:: as any*/),
                              (v37/*:: as any*/),
                              (v10/*:: as any*/),
                              (v9/*:: as any*/),
                              (v30/*:: as any*/),
                              (v8/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "durationFrom",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "durationTo",
                                "storageKey": null
                              },
                              (v39/*:: as any*/),
                              (v40/*:: as any*/),
                              (v41/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "certificate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "birthDate",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "referralLetter",
                            "args": null,
                            "concreteType": "de_ReferralLetter",
                            "kind": "LinkedField",
                            "name": "de_referralLetter",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              (v36/*:: as any*/),
                              (v12/*:: as any*/),
                              (v38/*:: as any*/),
                              (v37/*:: as any*/),
                              (v10/*:: as any*/),
                              (v9/*:: as any*/),
                              (v30/*:: as any*/),
                              (v8/*:: as any*/),
                              (v39/*:: as any*/),
                              (v40/*:: as any*/),
                              (v41/*:: as any*/),
                              (v7/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "reasoning",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "referralId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "medicationIds",
                                "storageKey": null
                              },
                              (v24/*:: as any*/),
                              (v25/*:: as any*/),
                              (v6/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "de_ProgressNote",
                                "kind": "LinkedField",
                                "name": "progressNote",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "de_PointOfCare",
                                    "kind": "LinkedField",
                                    "name": "pointOfCare",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PointOfCareSpecialty",
                                        "kind": "LinkedField",
                                        "name": "pointOfCareSpecialty",
                                        "plural": false,
                                        "selections": [
                                          (v3/*:: as any*/),
                                          (v16/*:: as any*/),
                                          (v32/*:: as any*/),
                                          (v31/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v3/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "betterDocResult",
                            "args": null,
                            "concreteType": "de_ProgressNoteBetterDocResult",
                            "kind": "LinkedField",
                            "name": "de_betterDocResult",
                            "plural": false,
                            "selections": [
                              (v42/*:: as any*/),
                              (v13/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "de_BetterDocRecommendedCareProvider",
                                "kind": "LinkedField",
                                "name": "recommendedCareProviders",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "position",
                                    "storageKey": null
                                  },
                                  (v26/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "workplaceName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "street",
                                    "storageKey": null
                                  },
                                  (v23/*:: as any*/),
                                  (v22/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "carePlanSummary",
                            "args": null,
                            "concreteType": "De_carePlanSummaryConnection",
                            "kind": "LinkedField",
                            "name": "de_carePlanSummary",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "De_carePlanSummaryEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CarePlanSummary",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CarePlanTreatmentPlan",
                                        "kind": "LinkedField",
                                        "name": "treatmentPlan",
                                        "plural": false,
                                        "selections": [
                                          (v33/*:: as any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "followUpTreatment",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "recommendedTreatment",
                                            "storageKey": null
                                          },
                                          (v34/*:: as any*/),
                                          (v35/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v36/*:: as any*/),
                                      (v12/*:: as any*/),
                                      (v38/*:: as any*/),
                                      (v37/*:: as any*/),
                                      (v10/*:: as any*/),
                                      (v9/*:: as any*/),
                                      (v30/*:: as any*/),
                                      (v8/*:: as any*/),
                                      (v39/*:: as any*/),
                                      (v40/*:: as any*/),
                                      (v41/*:: as any*/),
                                      (v11/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v43/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v44/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "carePlanSummary",
                            "args": null,
                            "filters": null,
                            "handle": "connection",
                            "key": "ProgressNoteConnection_carePlanSummary",
                            "kind": "LinkedHandle",
                            "name": "de_carePlanSummary"
                          },
                          {
                            "alias": "prescription",
                            "args": null,
                            "concreteType": "de_Prescription",
                            "kind": "LinkedField",
                            "name": "de_prescription",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              (v37/*:: as any*/),
                              (v38/*:: as any*/),
                              (v39/*:: as any*/),
                              (v40/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "de_Medication",
                                "kind": "LinkedField",
                                "name": "medications",
                                "plural": true,
                                "selections": [
                                  (v3/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v8/*:: as any*/),
                              (v30/*:: as any*/),
                              (v36/*:: as any*/),
                              (v41/*:: as any*/),
                              (v7/*:: as any*/),
                              (v12/*:: as any*/),
                              (v9/*:: as any*/),
                              (v10/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sentAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sentBy",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MedicalReportAttachmentConnection",
                            "kind": "LinkedField",
                            "name": "medicalReportAttachments",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MedicalReportAttachmentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MedicalReportAttachment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*:: as any*/),
                                      (v18/*:: as any*/),
                                      (v9/*:: as any*/),
                                      (v19/*:: as any*/),
                                      (v20/*:: as any*/),
                                      (v21/*:: as any*/),
                                      (v12/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "reportType",
                                        "storageKey": null
                                      },
                                      (v42/*:: as any*/),
                                      (v11/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v43/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v44/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "filters": null,
                            "handle": "connection",
                            "key": "ProgressNoteConnection_medicalReportAttachments",
                            "kind": "LinkedHandle",
                            "name": "medicalReportAttachments"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "De_recommendedMedicationsConnection",
                            "kind": "LinkedField",
                            "name": "de_recommendedMedications",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "De_recommendedMedicationsEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "de_RecommendedMedication",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v12/*:: as any*/),
                                      (v7/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "medicationId",
                                        "storageKey": null
                                      },
                                      (v3/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "de_Medication",
                                        "kind": "LinkedField",
                                        "name": "medication",
                                        "plural": false,
                                        "selections": [
                                          (v11/*:: as any*/),
                                          (v3/*:: as any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "refuseSubstitutes",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "numberOfPackages",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "endDate",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "eveningDosage",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "internalNotes",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isPrescriptionRequired",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "morningDosage",
                                            "storageKey": null
                                          },
                                          (v26/*:: as any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "nightDosage",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "noonDosage",
                                            "storageKey": null
                                          },
                                          (v7/*:: as any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "pharmaceuticalCentralNumber",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "startDate",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "unit",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "usageInstructions",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "composition",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "type",
                                            "storageKey": null
                                          },
                                          (v10/*:: as any*/),
                                          (v30/*:: as any*/),
                                          (v9/*:: as any*/),
                                          (v8/*:: as any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isPermanentPrescription",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v11/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v43/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v44/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "filters": null,
                            "handle": "connection",
                            "key": "ProgressNoteConnection_de_recommendedMedications",
                            "kind": "LinkedHandle",
                            "name": "de_recommendedMedications"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "De_callTranscriptsConnection",
                            "kind": "LinkedField",
                            "name": "de_callTranscripts",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "De_callTranscriptsEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CallTranscript",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TranscriptEntry",
                                        "kind": "LinkedField",
                                        "name": "transcript",
                                        "plural": true,
                                        "selections": [
                                          (v3/*:: as any*/),
                                          (v5/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "callTranscriptEndedAt",
                                        "storageKey": null
                                      },
                                      (v11/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v43/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v44/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "filters": null,
                            "handle": "connection",
                            "key": "ProgressNoteConnection_de_callTranscripts",
                            "kind": "LinkedHandle",
                            "name": "de_callTranscripts"
                          }
                        ],
                        "storageKey": null
                      },
                      (v43/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v44/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "connection",
                "key": "EpisodeOfCareProgressNotesConnection_progressNotes",
                "kind": "LinkedHandle",
                "name": "progressNotes"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RelatedCondition",
                "kind": "LinkedField",
                "name": "relatedConditions",
                "plural": true,
                "selections": [
                  (v3/*:: as any*/),
                  (v6/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "episodeOfCare",
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "de_EpisodeOfCare",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "addConnections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "de_EpisodeOfCareEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "5f1e035b977d3535182c47a0c52e6c5a",
    "metadata": {},
    "name": "deCreateOrReuseEpisodeOfCareMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c9db5a1919ba65b6621bd47124304409";

export default node;
